import { Button, Heading, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import ConfirmModal from '../../../components/confirmModal'
import Paginator from '../../../components/paginator'
import { formatDateTime } from '../../../helpers'
import { IAbraMidiaListItem, IAbraMidiaRaw } from '../../../interfaces/AbraMidia'
import AbraMidiaService from '../../../services/AbraMidia/AbraMidiaService'
import { AbraMidiaInfoModal } from './AbraMidiaInfoModal'

export function AbraMidiaPage() {
  const abraMidiaService = new AbraMidiaService()
  const toast = useToast()
  const [data, setData] = useState<IAbraMidiaListItem[]>([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(3)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [deletingId, setDeletingId] = useState<number | null>(null)
  const [infoModalTextHeader, setInfoModalTextHeader] = useState('')
  const [infoModalCode, setInfoModalCode] = useState('')

  const handleOpenModal = (title: string, code: string) => {
    setInfoModalTextHeader(title)
    setInfoModalCode(code)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const loadAbraMidias = (page: number) => {
    abraMidiaService.list({ page }).then((response) => {
      setData(
        response.data.data.map((abraMidia: IAbraMidiaRaw) => ({
          id: abraMidia.id,
          title: abraMidia.title,
          code: abraMidia.code,
          createdAt: formatDateTime(abraMidia.created_at),
          updatedAt: formatDateTime(abraMidia.updated_at)
        }))
      )
      setPage(response.data.current_page)
      setTotalPages(Math.ceil(response.data.total / response.data.per_page))
    })
  }

  const handleDelete = async () => {
    if (!deletingId) return

    setShowConfirmModal(false)
    abraMidiaService.delete(deletingId).then(() => {
      toast({
        title: 'ABRA Mídia excluído com sucesso!',
        status: 'success',
        duration: 5000,
        isClosable: true
      })
    })
    loadAbraMidias(1)
  }

  useEffect(() => {
    loadAbraMidias(1)
  }, [])

  return (
    <>
      <Link to="/abra-midia/new">
        <Button
          position="fixed"
          bottom="5"
          right="5"
          size="lg"
          colorScheme="magenta"
          borderRadius="full"
          boxShadow="lg"
          width={16}
          height={16}
        >
          <i className="lni lni-plus"></i>
        </Button>
      </Link>

      <Heading as="h1" size="lg" marginBottom="5" mb="10" textTransform="uppercase">
        ABRA Mídia
      </Heading>

      <TableContainer>
        <Table>
          <Thead>
            <Tr>
              <Th>#</Th>
              <Th>Nome</Th>
              <Th>Criado em</Th>
              <Th>Atualizado em</Th>
              <Th>Ações</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.map((item) => {
              return (
                <Tr key={item.id}>
                  <Td>{item.id}</Td>
                  <Td>{item.title}</Td>
                  <Td>{item.createdAt}</Td>
                  <Td>
                    {item.updatedAt === item.createdAt ? (
                      <Text align={'center'} color="gray.500">
                        -
                      </Text>
                    ) : (
                      item.updatedAt
                    )}
                  </Td>
                  <Td>
                    <Button
                      colorScheme="green"
                      size="sm"
                      mr={2}
                      onClick={() => {
                        handleOpenModal(item.title, item.code)
                      }}
                    >
                      <i className="lni lni-link"></i>
                    </Button>
                    <Link to={`/abra-midia/${item.id}`}>
                      <Button colorScheme="blue" size="sm" mr={2}>
                        <i className="lni lni-pencil"></i>
                      </Button>
                    </Link>
                    <Button
                      colorScheme="red"
                      size="sm"
                      onClick={() => {
                        setShowConfirmModal(true)
                        setDeletingId(item.id)
                      }}
                    >
                      <i className="lni lni-trash-can"></i>
                    </Button>
                  </Td>
                </Tr>
              )
            })}
          </Tbody>
        </Table>
      </TableContainer>
      <Paginator
        page={page}
        totalPages={totalPages}
        changePage={(page: number) => {
          setPage(page)
          loadAbraMidias(page)
        }}
      />

      <AbraMidiaInfoModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        textHeader={infoModalTextHeader}
        code={infoModalCode}
      />

      <ConfirmModal
        isOpen={showConfirmModal}
        onClose={() => {
          setShowConfirmModal(false)
        }}
        onConfirm={handleDelete}
        textHeader="Confirmar Exclusão"
        textBody="Tem certeza que deseja excluir?"
      />
    </>
  )
}
